export default __webpack_public_path__ + "static/media/008.d1866a83.jpg";